import React, { useEffect } from "react";

export default function PayFail() {

    useEffect(() => {
        // dispatch(setUserInfoTest({ value: 2 }));
        window.opener.location.reload();
        window.close();
    }, []);


    return (
        <div className="content" >
            pay fail..
        </div>
    );
}

